// extracted by mini-css-extract-plugin
export default {"orderDetails":"orderDetails_orderDetails__vfgs0","orderDetails__head":"orderDetails_orderDetails__head__VuiLY"};